import { defineMessages } from "@ai360/core/intl";

export const messages = defineMessages({
    title: {
        id: "portalBoundaryUpdate.title",
        defaultMessage: "Portal Boundary Update - JD Operations Center - {farm}{field}",
    },
    confirmationTitle: {
        id: "portalBoundaryUpdate.confirmationTitle",
        defaultMessage: "Confirm",
    },
    confirmationMessage: {
        id: "portalBoundaryUpdate.confirmationMessage",
        defaultMessage:
            "Are you sure you want to update the JD Ops Center boundary?  This process will immediately update the selected boundary in JD Ops Center and cannot be reverted.",
    },
    cancel: { id: "portalBoundaryUpdate.cancel", defaultMessage: "Cancel" },
    update: { id: "portalBoundaryUpdate.update", defaultMessage: "Update" },
    updateAi360Boundary: {
        id: "portalBoundaryUpdate.updateAi360Boundary",
        defaultMessage: "Update {system} boundary to match JD Ops Center boundary{jdFieldName}",
    },
    updateFailed: {
        id: "portalBoundaryUpdate.updateFailed",
        defaultMessage: "Unable to update the boundary in the JD Ops Center",
    },
    updateJdOpsCenterBoundary: {
        id: "portalBoundaryUpdate.updateJdOpsCenterBoundary",
        defaultMessage: "Update JD Ops Center boundary{jdFieldName} to match {system} boundary",
    },
    updateJdBoundarySucceeded: {
        id: "portalBoundaryUpdate.updateSucceeded",
        defaultMessage: "Updated boundary in the JD Ops Center",
    },
});
